import { useApp } from "../state/store";

export const BusyOverlay = () => {
  const busy = useApp((s) => s.busy);
  if (!busy.active) return null;
  return (
    <div className="overlay">
      <div className="spinner" />
      <div className="busy-text">{busy.text}</div>
    </div>
  );
};
